import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import RightGridCell from "./RightGridCell";

import { MatrixRow, MatrixTask } from "@/models/matrix";
import {
  labelFromByLinkageTask,
  labelToByLinkageTask,
  LinkageTask,
  TaskStatus,
  TaskSwitcherStatusType,
} from "@/models/tasks";
import { RootState } from "@/reducers/types";

type Props = {
  row: MatrixRow;
  index: number;
  linkageTasks: LinkageTask[];
  showTaskEditor: (taskId, isStatus, linkageInfo) => void;
  switcherStatus: TaskSwitcherStatusType;
  changeTaskStatus: (item_id, task, status) => void;
  isChiba: boolean;
  setDetailSubmenu: (info: {
    x;
    y;
    rowIndex;
    task;
    isExtraRequestDisabled: boolean;
    itemName: string;
    processName: string;
  }) => void;
  clearDetailSubmenu: () => void;
};

const RightGridRow: React.FC<Props> = (props) => {
  const { linkageTasks, setDetailSubmenu, clearDetailSubmenu } = props;

  const taskMap = useMemo(() => {
    return new Map(props.row.tasks.map((task: MatrixTask) => [task.process_id, task]));
  }, [props.row.tasks]);
  const { columns, configHideInvalidCols, processIdsWithValidTasks } = useSelector((state: RootState) => state.matrix);
  const filteredColumns = useMemo(
    () => columns.filter((column) => !configHideInvalidCols || processIdsWithValidTasks.includes(column.process_id)),
    [columns, configHideInvalidCols, processIdsWithValidTasks]
  );

  if (!taskMap.size) return <></>;

  return (
    <tr>
      {filteredColumns.map((column, colIndex) => {
        const task = taskMap.get(column.process_id);
        if (!task) return <></>;
        let type = "from";
        let content = [];

        if (task.valid_flg && linkageTasks) {
          content = linkageTasks
            .filter((val) => val.from_task_id === task.task_id)
            .map((val) => labelToByLinkageTask(val));

          if (content.length === 0) {
            content = linkageTasks
              .filter((val) => val.to_task_id === task.task_id)
              .map((val) => labelFromByLinkageTask(val));
            if (content.length > 0) type = "to";
          }
        }
        const keyTasks = column.key_processes.map((key) => taskMap.get(key)).filter((v) => v);
        const canComplete =
          keyTasks.length === 0 || keyTasks.every((t) => !t.valid_flg || t.status === TaskStatus.COMPLETE);

        return (
          <RightGridCell
            // @ts-ignore 型を合わせる。項目が違うので明細のタスクと一覧のタスクで異なる型にする
            task={task}
            itemId={props.row.item_id}
            rowIndex={props.index}
            colIndex={colIndex}
            key={colIndex}
            switcherStatus={props.switcherStatus}
            canComplete={canComplete}
            showTaskEditor={props.showTaskEditor}
            changeTaskStatus={props.changeTaskStatus}
            linkageInfo={{ type, num: content.length, content }}
            isChiba={props.isChiba}
            row={props.row}
            isExtraRequestDisabled={!column.output_flg || !!column.schedule_mapping_flg}
            processName={column.process_name}
            setDetailSubmenu={setDetailSubmenu}
            clearDetailSubmenu={clearDetailSubmenu}
            disableDrag={configHideInvalidCols}
          />
        );
      })}
    </tr>
  );
};

export default RightGridRow;
